module.exports = __webpack_public_path__ + "static/media/office.bffb1126.png";